import { render, staticRenderFns } from "./GridExcepcionesTotales.vue?vue&type=template&id=0bb53905&"
import script from "./GridExcepcionesTotales.vue?vue&type=script&lang=js&"
export * from "./GridExcepcionesTotales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports